
export const ShellPremiumClubName = 'ShellPremiumClubReport'